module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_try_on_dress_03-fc55b4e5ccfdb8a7abebe0cc8184e1d1.jpg";